export const initializeLinkListCards = () => {
  const blocks = document.querySelectorAll('[data-component="link-list-cards"]')

  blocks.forEach(block => {
    const filterButtons = block.querySelectorAll('[data-component="link-list-cards-filter"]')
    const items = Array.from(block.querySelectorAll('[data-component="link-list-cards-item"]'))
    const swiperElement = block.querySelector('.swiper')

    const render = activeCategory => {
      items.forEach(item => {
        const categories = (item.dataset.categories || '').split(',').filter(Boolean)
        const match = !activeCategory || categories.includes(activeCategory)
        const target = item.closest('.swiper-slide') || item
        target.classList.toggle('hidden', !match)
      })

      if (swiperElement?.swiperInstance) {
        swiperElement.swiperInstance.update()
        swiperElement.swiperInstance.slideTo(0, 0)
      }
    }

    filterButtons.forEach(button => {
      button.addEventListener('click', () => {
        filterButtons.forEach(btn => {
          btn.dataset.active = btn === button ? 'true' : 'false'
        })

        render(button.dataset.category || '')
      })
    })
  })
}
